import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { ApAgingReportTabPanel } from "@/screens/FinancialReporting/subfeatures/ApAgingReport/components/ApAgingReportTabPanel"
import { apAgingReportSearchParamsSchema } from "@/screens/FinancialReporting/subfeatures/ApAgingReport/types/searchParams"

export const Route = createFileRoute("/app/financial-reporting/_layout/ap-aging-report")({
  validateSearch: zodValidator(apAgingReportSearchParamsSchema),
  component: ApAgingReportTabPanel,
})
